import { useRouteError } from "react-router-dom";

const Error = () => {
  const error = useRouteError();
  console.error(error); // Helpful for debugging

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-red-100 to-yellow-100 text-center px-4">
      <h1 className="text-6xl font-bold text-red-600 drop-shadow-sm mb-4">
        {error.status || 404} - {error.statusText || "Page Not Found"}
      </h1>
      <p className="text-lg text-gray-700 mb-6">
        Oops! Something went wrong. 😢
      </p>
      {error.data && (
        <pre className="text-sm text-gray-500 bg-gray-100 rounded-lg p-4 shadow-inner max-w-lg overflow-x-auto mb-6">
          {error.data}
        </pre>
      )}
      <a
        href="/"
        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-xl transition-transform transform hover:scale-105 shadow-lg"
      >
        Go to Home
      </a>
    </div>
  );
};

export default Error;
